// noinspection JSUnusedGlobalSymbols

/**
 *
 * @param length
 * @returns {string}
 */
function randomAlphaString(length) {
	let result = '';
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

/**
 * @param length
 * @returns {string}
 */
function randomNumber(length) {
	let result = '';
	const characters = '123456789';
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

/**
 * Returns a random unused class name meant to be used as an Id
 *
 * @param {string} prefix
 */
function randomUniqueClassName(prefix = '') {
	let randomClassName;
	do {
		randomClassName = prefix + randomAlphaString(24);

	} while (document.querySelector(`.${randomClassName}`))

	return randomClassName;
}

/**
 * Returns a random unused DOM id
 *
 * @param {string} prefix
 */
function randomUniqueDomId(prefix = '') {
	let randomId;
	do {
		randomId = prefix + randomAlphaString(24);

	} while (document.querySelector(`#${randomId}`))

	return randomId;
}


const uniqueIdHistory = {};

/**
 * Returns a random never used string id
 *
 * @param {string} prefix
 */
function randomUniqueId(prefix = '') {
	let randomId;
	do {
		randomId = prefix + randomAlphaString(24);
	} while (uniqueIdHistory[randomId])

	// Flag as used for future calls
	uniqueIdHistory[randomId] = true;

	return randomId;
}

export {
	randomNumber,
	randomAlphaString,
	randomUniqueClassName,
	randomUniqueDomId,
	randomUniqueId
}
